import { AxiosResponse } from "axios";

import { removeEmpty } from "../../utils/removeEmpty";
import {
  IAuthProps,
  IAuthResponse,
  IDenunciaCompletaDTO,
  IDenunciaDTO,
  IDenunciaPageDTO,
  IGetDenunciaProps,
} from "../../types/denuncia";
import { ApiDenuncia } from "../../Apis/Denuncia";

const basePath = "/denuncias";

export class Denuncia {
  static async get(
    props?: IGetDenunciaProps
  ): Promise<AxiosResponse<IDenunciaPageDTO>> {
    let params = "";
    if (props) {
      params = new URLSearchParams(removeEmpty(props)).toString();
    }
    return params
      ? ApiDenuncia.get(`${basePath}?${params}`)
      : ApiDenuncia.get(basePath);
  }

  static async getById(
    uuid: string
  ): Promise<AxiosResponse<IDenunciaCompletaDTO>> {
    return ApiDenuncia.get(`${basePath}/${uuid}`);
  }

  static async auth(props: IAuthProps): Promise<AxiosResponse<IAuthResponse>> {
    return ApiDenuncia.post(`/api-token-auth/`, props);
  }
}
